import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { useToast } from '@bonusly/design-system';
import { useHttpClient } from '@bonusly/http-client';

import { Toast } from '../components/toast/toast';
import { Feedback } from '../lib';
import { QueryKey } from '../types/query-key';

interface UseResendEvaluationOptions {
	onSuccess?: () => void;
}

export const useResendEvaluation = (evaluation: Feedback, options: UseResendEvaluationOptions = {}) => {
	const toast = useToast();
	const { t } = useTranslation('feedback');
	const http = useHttpClient('v2');
	const queryClient = useQueryClient();

	return useMutation(async () => {
		await http.patch('/constructive_feedback/feedback/' + evaluation.id, {
			resend: true,
		});

		queryClient.invalidateQueries(['evaluations', evaluation.id]);
		queryClient.invalidateQueries([QueryKey.ConsolidatedFeedbackIndex]);

		toast({
			position: 'bottom-right',
			render: () => {
				return <Toast isCloseable message={t('pending.resend_success')} status="success" />;
			},
		});

		options.onSuccess?.();
	});
};
